import React from 'react'
import { Link,useNavigate } from 'react-router-dom'
// import blackLogo from '../../../assets/image/logo2.png'
// import whiteLogo from '../../../assets/image/whiteLogo.png'
import logosvg from '../../../assets/image/Stellare bijoux logo design-01 (2).svg'
import './style/logo.css'

function Logo() {
  let navigate = useNavigate();
  // let location = useLocation();
  // const [scrollPosition, setScrollPosition] = useState(0);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrollPosition(window.scrollY);
  //   };

  //   if (location.pathname === '/') {
  //     window.addEventListener('scroll', handleScroll);
  //   }

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [location.pathname]); 

  // const logoSrc = location.pathname === '/' && scrollPosition <= 0.5 ? whiteLogo : blackLogo;

//   let navigate = useNavigate()
//   const [scrollPosition, setScrollPosition] = useState(0);
// useEffect(() => {
//   const handleScroll = () => {
//     setScrollPosition(window.scrollY);
//   };

//   window.addEventListener('scroll', handleScroll);
//   return () => {
//     window.removeEventListener('scroll', handleScroll);
//   };
// }, []);

// const logoSrc = scrollPosition > 1 ? blackLogo : whiteLogo;

    return (
        <div>
            <span className="inline-block  text-center text-3xl font-medium cursor-pointer" onClick={() => navigate("/")}>
                <Link to="/" > <img src={logosvg} alt="stellare bijoux" style={{ objectFit: 'cover' }} className="Logo" id='myIcons'/></Link>

            </span>
        </div>
    )
}

export default Logo
